import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const NAV = [
  { to: "/", label: "Home", testId: "nav-link-home" },
  { to: "/services", label: "Services", testId: "nav-link-services" },
  { to: "/pricing", label: "Pricing", testId: "nav-link-pricing" },
  { to: "/how-it-works", label: "How It Works", testId: "nav-link-how-it-works" },
  { to: "/about", label: "About", testId: "nav-link-about" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#070913]/80 backdrop-blur-xl">
      <div className="container-x flex h-16 items-center justify-between sm:h-[72px]">
        <Link to="/" data-testid="nav-brand-logo" aria-label="LeadCerebro home" onClick={() => setOpen(false)}>
          <Logo />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testId}
              className={({ isActive }) =>
                `relative text-sm font-medium transition-colors duration-300 ${
                  isActive ? "text-volt" : "text-mist hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/book-demo"
            data-testid="nav-cta-button"
            className="btn-primary hidden !px-5 !py-2.5 sm:inline-flex"
          >
            Book a Free Demo <ArrowRight size={15} strokeWidth={2.5} />
          </Link>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="rounded-lg border border-white/10 p-2 text-slate-200 lg:hidden"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            key={location.pathname}
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-white/5 bg-[#070913]/95 backdrop-blur-xl lg:hidden"
            aria-label="Mobile"
          >
            <div className="container-x flex flex-col gap-1 py-4">
              {[...NAV, { to: "/book-demo", label: "Book a Demo", testId: "nav-link-book-demo" }].map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  data-testid={`mobile-${item.testId}`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `rounded-lg px-3 py-3 text-base font-medium ${
                      isActive ? "bg-surface text-volt" : "text-slate-200"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
